import graphql__d41c55d2b74e92b719f0 from "./__generated__/CustomerPaymentView_customerAccount.graphql.ts";import * as React from "react";
import {connect, ConnectedProps} from "react-redux";
import {useOutletContext} from "react-router";
import {hideModal, showModal} from "../store/actions";
import NoData from "./presentational/NoData";
import {useRefetchableFragment} from "react-relay/hooks";
import {graphql} from "react-relay";
import DetailedPaymentMethodList from "./DetailedPaymentMethodList";
import Panel from "./presentational/Panel";
import SetUpStripePaymentMethodDialog from "./dialog/SetUpStripePaymentMethodDialog";
import {faUsers} from "@fortawesome/pro-regular-svg-icons";
import ActionButton from "./presentational/button/ActionButton";
import SetUpOnAccountPaymentMethodDialog from "./dialog/SetUpOnAccountPaymentMethodDialog";
import {useIntl} from "react-intl";

type Props = {}

const connector = connect(undefined, {
    dispatchShowModal: showModal,
    dispatchHideModal: hideModal
});

type CustomerPaymentViewProps = Props & ConnectedProps<typeof connector>;

const CustomerPaymentView: React.FC<CustomerPaymentViewProps> = (props) => {
    const intl = useIntl();
    const queryRef: any = useOutletContext();
    const {dispatchShowModal, dispatchHideModal} = props
    const [customerAccount] = useRefetchableFragment(
        graphql__d41c55d2b74e92b719f0,
        queryRef
    );

    const showSetUpOnAccountPaymentMethodDialog = () => {
        dispatchShowModal({
            body: (<SetUpOnAccountPaymentMethodDialog handleCloseDialog={dispatchHideModal} customerAccountIdentifier={customerAccount.id}/>)
        })
    };

    const showSetUpStripePaymentMethodDialog = () => {
        dispatchShowModal({
            body: (<SetUpStripePaymentMethodDialog handleCloseDialog={dispatchHideModal} customerAccountIdentifier={customerAccount.id}/>)
        })
    };

    return (
        <Panel headline={intl.formatMessage({id: 'view.payment.headline'})} fullWidthChildren={true}>
            {customerAccount.paymentMethods.length === 0 &&
                <NoData
                    icon={faUsers}
                    headline={intl.formatMessage({id: 'view.payment.noPaymentMethods'})}
                    description={intl.formatMessage({id: 'view.payment.noPaymentMethodsDescription'})}
                />
            }
            {customerAccount.paymentMethods.length > 0 && (
                <DetailedPaymentMethodList queryRef={customerAccount}/>
            )}
            <div className="text-center py-10">
                <ActionButton onClick={e => showSetUpStripePaymentMethodDialog()} label={intl.formatMessage({id: 'view.payment.addCardOrSepa'})}/>
                <ActionButton onClick={e => showSetUpOnAccountPaymentMethodDialog()} label={intl.formatMessage({id: 'view.payment.addOnAccount'})}/>
            </div>
        </Panel>
    )
}

export default connector(CustomerPaymentView);
